import PromptChatContextIndicator, { PromptChatContextButton } from './PromptChatContextIndicator';
import { useDesignerScreenPreview } from './DesignerScreenContext';

type ContextProps = { expanded: boolean; contentId: string };

export function ArchitectContextButton(props: ContextProps & { onToggle: () => void }) {
	const attributes = useDesignerScreenPreview();
	return <PromptChatContextButton {...props} attributes={attributes} />;
}

export default function ArchitectContextIndicator(props: ContextProps & { onClose: () => void }) {
	const attributes = useDesignerScreenPreview();
	return <PromptChatContextIndicator {...props} attributes={attributes} emptyText="No current screen or ChangeSet selected." />;
}
